<template>
  <b-container fluid id="home-top" class="d-table px-0">
    <b-row class="">
      <b-col class="d-none d-lg-table-cell px-0">
        <b-carousel
          id="carousel1"
          class="w-100"
          style
          controls
          indicators
          background="#ababab"
          :interval="10000"

          img-height="500px"
          v-model="slide"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block w-100"
              style="objet-fit: cover;"

              height="500"
              src="../assets/Teller.jpg"
              alt="image slot"
            >
          </b-carousel-slide>
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block w-100"
              style="objet-fit: cover;"

              height="500"
              src="../assets/Jobs.jpg"
              alt="image slot"
            >
          </b-carousel-slide>
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block w-100"
              style="objet-fit: cover;"

              height="500"
              src="../assets/Huxley.jpg"
              alt="image slot"
            >
          </b-carousel-slide>
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block w-100"
              style="objet-fit: cover;"

              height="500"
              src="../assets/Ford.jpg"
              alt="image slot"
            >
          </b-carousel-slide>
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block w-100"
              style="objet-fit: cover;"

              height="500"
              src="../assets/Hastings.jpg"
              alt="image slot"
            >
          </b-carousel-slide>
        </b-carousel>
      </b-col>
      <div class="d-table-cell d-lg-none" align-v="top">
        <b-carousel
          id="carousel1"

          controls
          indicators
          background="#ababab"
          :interval="4000"

          img-height="500"
          v-model="slide"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block w-100"
              style="objet-fit: cover;"
              height="450px"
              src="../assets/Teller_small.jpg"
              alt="image slot"
            >
          </b-carousel-slide>
        </b-carousel>
      </div>
    </b-row>
  </b-container>
  <!-- <b-container fluid>
    <img src="../assets/456536.jpg" alt>
  </b-container>-->
</template>

<script>
export default {
  name: 'welcome',
  data () {
    return {
      slide: 0,
      sliding: null
    }
  },
  methods: {
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    }
  }
}
</script>

<style>
#home-top {
  /* display: table; */
  /* height: 500px; */
  width: 100%;
  /* background: url(../assets/teller.jpg) no-repeat; */
  /* background-size: cover; */
  text-align: center;
  color: #fff;
  font-size: 16px;
  /* position: relative; */
  /* margin-top: 60px; */
  padding-top: 38px;
}

h1.hero {
  line-height: 76px;
}
</style>
